import { render, staticRenderFns } from "./DetalleInscritosnotas.vue?vue&type=template&id=5fbc4c3a&"
import script from "./DetalleInscritosnotas.vue?vue&type=script&lang=js&"
export * from "./DetalleInscritosnotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports